import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "invitation-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-head pb-3" }
const _hoisted_6 = { class: "card-title" }
const _hoisted_7 = { class: "inner-wrap" }
const _hoisted_8 = {
  key: 0,
  class: "activity-block"
}
const _hoisted_9 = {
  key: 0,
  class: "activity-img"
}
const _hoisted_10 = {
  key: 1,
  class: "activity-img"
}
const _hoisted_11 = {
  key: 2,
  class: "activity-btn"
}
const _hoisted_12 = {
  key: 3,
  class: "activity-btn"
}
const _hoisted_13 = {
  key: 4,
  class: "activity-btn"
}
const _hoisted_14 = {
  key: 5,
  class: "activity-btn"
}
const _hoisted_15 = {
  key: 6,
  class: "activity-btn"
}
const _hoisted_16 = {
  key: 7,
  class: "activity-btn"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { class: "text-center inner-wrap pb-0" }
const _hoisted_20 = { class: "modal-wrap default-modal" }
const _hoisted_21 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "successModal",
  tabindex: "-1",
  "aria-labelledby": "inviteMember",
  "aria-hidden": "true"
}
const _hoisted_22 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_23 = { class: "modal-content text-center" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "msg-header" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "icon" }, [
    /*#__PURE__*/_createVNode("svg", {
      width: "1em",
      height: "1em",
      viewBox: "0 0 16 16",
      class: "bi bi-check-circle",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createVNode("path", {
        "fill-rule": "evenodd",
        d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
      }),
      /*#__PURE__*/_createVNode("path", {
        "fill-rule": "evenodd",
        d: "M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"
      })
    ])
  ])
], -1)
const _hoisted_25 = { class: "msg-body" }
const _hoisted_26 = { class: "modal-wrap default-modal" }
const _hoisted_27 = {
  class: "modal fade",
  id: "showInvitationDetails",
  tabindex: "-1",
  "aria-labelledby": "inviteMember",
  "aria-hidden": "true"
}
const _hoisted_28 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_29 = { class: "modal-content" }
const _hoisted_30 = { class: "modal-header" }
const _hoisted_31 = { class: "d-block" }
const _hoisted_32 = {
  key: 0,
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_33 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_34 = { class: "modal-body" }
const _hoisted_35 = {
  key: 0,
  class: "form-wrap pt-0"
}
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = { for: "exampleInputEmail1" }
const _hoisted_38 = {
  key: 1,
  class: "form-wrap pt-0"
}
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = { for: "exampleInputEmail1" }
const _hoisted_41 = {
  key: 2,
  class: "form-wrap pt-0"
}
const _hoisted_42 = { class: "form-group" }
const _hoisted_43 = { for: "exampleInputEmail1" }
const _hoisted_44 = {
  key: 3,
  class: "form-wrap pt-0"
}
const _hoisted_45 = { class: "form-group" }
const _hoisted_46 = { for: "exampleInputEmail1" }
const _hoisted_47 = {
  key: 0,
  class: "green-text"
}
const _hoisted_48 = {
  key: 1,
  class: "yellow-text"
}
const _hoisted_49 = {
  key: 2,
  class: "yellow-text"
}
const _hoisted_50 = {
  key: 4,
  class: "form-wrap pt-0"
}
const _hoisted_51 = { class: "form-group" }
const _hoisted_52 = { for: "exampleInputEmail1" }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_55 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_56 = {
  key: 5,
  class: "form-wrap pt-0"
}
const _hoisted_57 = { class: "form-group" }
const _hoisted_58 = { for: "exampleInputEmail1" }
const _hoisted_59 = { class: "modal-footer" }
const _hoisted_60 = {
  key: 0,
  class: "activity-btn"
}
const _hoisted_61 = {
  key: 1,
  class: "activity-btn"
}
const _hoisted_62 = { class: "modal-wrap default-modal" }
const _hoisted_63 = {
  class: "modal fade",
  id: "deleteInvitation",
  tabindex: "-1",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true"
}
const _hoisted_64 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_65 = { class: "modal-content" }
const _hoisted_66 = { class: "modal-header" }
const _hoisted_67 = {
  class: "modal-title",
  id: "deleteModalLabel"
}
const _hoisted_68 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_69 = { class: "modal-body" }
const _hoisted_70 = {
  class: "alert alert-danger mb-0",
  role: "alert"
}
const _hoisted_71 = {
  key: 0,
  class: "form-group"
}
const _hoisted_72 = { for: "exampleInputEmail1" }
const _hoisted_73 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_EmptyData = _resolveComponent("EmptyData")
  const _component_router_link = _resolveComponent("router-link")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")
  const _component_ToDoDetailsAttachment = _resolveComponent("ToDoDetailsAttachment")
  const _component_UpgradeSubscriptionModal = _resolveComponent("UpgradeSubscriptionModal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.state.isLoading && _ctx.pendingList.length==0)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("h1", _hoisted_6, _toDisplayString(_ctx.$t('invitation')), 1)
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_ErrorList, {
          errors: _ctx.data.error.errorsList,
          hasError: _ctx.data.error.hasError
        }, null, 8, ["errors", "hasError"]),
        (_ctx.pendingList && _ctx.pendingList.length)
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pendingList, (pending, pendingIndex) => {
                return (_openBlock(), _createBlock("div", {
                  class: _ctx.state.data.selectedUuid === pending.uuid ? 'activity-list mb-4 active': 'activity-list mb-4',
                  key: pendingIndex
                }, [
                  (pending.created_by.image)
                    ? (_openBlock(), _createBlock("div", _hoisted_9, [
                        _createVNode("img", {
                          src: pending.created_by.image,
                          alt: "",
                          title: pending.email
                        }, null, 8, ["src", "title"])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_10, [
                        _createVNode("img", {
                          src: 
                _ctx.data.imageBaseUrl
                  ? `${_ctx.data.imageBaseUrl}img/no-user.jpg`
                  : 'img/no-user.jpg'
              ,
                          alt: "",
                          title: pending.email
                        }, null, 8, ["src", "title"])
                      ])),
                  _createVNode("p", null, [
                    _createTextVNode(_toDisplayString(pending.description) + " ", 1),
                    _createVNode("strong", null, _toDisplayString(pending.createdLatest), 1)
                  ]),
                  (pending.type === 7 || pending.type === 5)
                    ? (_openBlock(), _createBlock("div", _hoisted_11, [
                        (!pending.todo_id)
                          ? (_openBlock(), _createBlock("a", {
                              key: 0,
                              href: "javascript:void(0)",
                              class: "btn default-btn",
                              onClick: ($event: any) => (_ctx.jobEstimationDetails(pending))
                            }, _toDisplayString(pending.type === 5 ? _ctx.$t('view_estimation') : _ctx.$t('view_details')), 9, ["onClick"]))
                          : (_openBlock(), _createBlock("a", {
                              key: 1,
                              href: "javascript:void(0)",
                              class: "btn default-btn",
                              onClick: ($event: any) => (_ctx.detailsModal(pending))
                            }, _toDisplayString(_ctx.$t('view_details')), 9, ["onClick"]))
                      ]))
                    : _createCommentVNode("", true),
                  (pending.type === 6 || pending.type === 10)
                    ? (_openBlock(), _createBlock("div", _hoisted_12, [
                        _createVNode("a", {
                          href: "javascript:void(0)",
                          class: "btn default-btn",
                          onClick: ($event: any) => (_ctx.detailsModal(pending))
                        }, _toDisplayString(pending.type === 6 ? _ctx.$t('view_phase') : _ctx.$t('view_task')), 9, ["onClick"])
                      ]))
                    : _createCommentVNode("", true),
                  (pending.type === 8 )
                    ? (_openBlock(), _createBlock("div", _hoisted_13, [
                        _createVNode("a", {
                          href: "javascript:void(0)",
                          class: "btn default-btn",
                          onClick: ($event: any) => (_ctx.projectInvitationDetail(pending))
                        }, _toDisplayString(_ctx.$t('view_details')), 9, ["onClick"])
                      ]))
                    : _createCommentVNode("", true),
                  (pending.type === 1 )
                    ? (_openBlock(), _createBlock("div", _hoisted_14, [
                        _createVNode("a", {
                          href: "javascript:void(0)",
                          class: "btn default-btn",
                          onClick: ($event: any) => (_ctx.redirectToChannelInvitation(pending.uuid))
                        }, _toDisplayString(_ctx.$t('view_channel')), 9, ["onClick"])
                      ]))
                    : (pending.type != 4)
                      ? (_openBlock(), _createBlock("div", _hoisted_15))
                      : (_openBlock(), _createBlock("div", _hoisted_16, [
                          _createVNode("a", {
                            href: "javascript:void(0)",
                            class: "btn default-btn",
                            onClick: ($event: any) => (_ctx.viewInvitationDetail(pending))
                          }, _toDisplayString(_ctx.$t('view_contract')), 9, ["onClick"])
                        ]))
                ], 2))
              }), 128))
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_17, [
              _createVNode("div", _hoisted_18, [
                _createVNode(_component_EmptyData, {
                  title: _ctx.title,
                  heading: _ctx.heading
                }, null, 8, ["title", "heading"])
              ]),
              _createVNode("div", _hoisted_19, [
                _createVNode(_component_router_link, {
                  to: { name: 'admin-dashboard' },
                  class: "btn default-btn outline"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('redirect_to_dashboard')), 1)
                  ]),
                  _: 1
                })
              ])
            ]))
      ])
    ]),
    _createVNode("div", _hoisted_20, [
      _createVNode("div", _hoisted_21, [
        _createVNode("div", _hoisted_22, [
          _createVNode("div", _hoisted_23, [
            _hoisted_24,
            _createVNode("div", _hoisted_25, [
              _createVNode("h3", null, _toDisplayString(_ctx.$t('successful')), 1)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 1,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_26, [
      _createVNode("div", _hoisted_27, [
        _createVNode("div", _hoisted_28, [
          _createVNode("div", _hoisted_29, [
            _createVNode("div", _hoisted_30, [
              _createVNode("div", _hoisted_31, [
                (
                    _ctx.state.data.selectedInvition.phase &&
                    _ctx.state.data.selectedInvition.phase.name
                  )
                  ? (_openBlock(), _createBlock("h5", _hoisted_32, _toDisplayString(_ctx.$t('view_details_of')) + " " + _toDisplayString(_ctx.state.data.selectedInvition.phase.name), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideInvitationDetails && _ctx.hideInvitationDetails(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_33
              ])
            ]),
            _createVNode("div", _hoisted_34, [
              (
                  _ctx.state.data.selectedInvition.phase &&
                  _ctx.state.data.selectedInvition.phase.name
                )
                ? (_openBlock(), _createBlock("div", _hoisted_35, [
                    _createVNode("div", _hoisted_36, [
                      _createVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('name')), 1),
                      _createVNode("p", null, _toDisplayString(_ctx.state.data.selectedInvition.phase.name), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (
                  _ctx.state.data.selectedInvition.phase &&
                  _ctx.state.data.selectedInvition.phase.description
                )
                ? (_openBlock(), _createBlock("div", _hoisted_38, [
                    _createVNode("div", _hoisted_39, [
                      _createVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('description')), 1),
                      _createVNode("p", null, _toDisplayString(_ctx.state.data.selectedInvition.phase.description), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (
                  _ctx.state.data.selectedInvition.phase &&
                  _ctx.state.data.selectedInvition.phase.budget
                )
                ? (_openBlock(), _createBlock("div", _hoisted_41, [
                    _createVNode("div", _hoisted_42, [
                      _createVNode("label", _hoisted_43, _toDisplayString(_ctx.$t('estimation')), 1),
                      _createVNode("p", null, _toDisplayString(_ctx.state.data.selectedInvition.phase.budget), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (
                  _ctx.state.data.selectedInvition.phase &&
                  _ctx.state.data.selectedInvition.phase.priority_id
                )
                ? (_openBlock(), _createBlock("div", _hoisted_44, [
                    _createVNode("div", _hoisted_45, [
                      _createVNode("label", _hoisted_46, _toDisplayString(_ctx.$t('priority')), 1),
                      _createVNode("p", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('priority')) + " : ", 1),
                        (_ctx.state.data.selectedInvition.phase.priority_id === 3)
                          ? (_openBlock(), _createBlock("span", _hoisted_47, _toDisplayString(_ctx.$t('high')), 1))
                          : (
                        _ctx.state.data.selectedInvition.phase.priority_id === 2
                      )
                            ? (_openBlock(), _createBlock("span", _hoisted_48, _toDisplayString(_ctx.$t('medium')), 1))
                            : (_openBlock(), _createBlock("span", _hoisted_49, _toDisplayString(_ctx.$t('low')), 1))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (
                  _ctx.state.data.selectedInvition.phase &&
                  _ctx.state.data.selectedInvition.phase.start_date
                )
                ? (_openBlock(), _createBlock("div", _hoisted_50, [
                    _createVNode("div", _hoisted_51, [
                      _createVNode("label", _hoisted_52, _toDisplayString(_ctx.$t('date')), 1),
                      _createVNode("p", null, [
                        (_ctx.state.data.selectedInvition.phase.start_date)
                          ? (_openBlock(), _createBlock("span", _hoisted_53, _toDisplayString(_ctx.state.data.selectedInvition.phase.start_date), 1))
                          : _createCommentVNode("", true),
                        _hoisted_54,
                        (_ctx.state.data.selectedInvition.phase.end_date)
                          ? (_openBlock(), _createBlock("span", _hoisted_55, _toDisplayString(_ctx.state.data.selectedInvition.phase.end_date), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (
                  _ctx.state.data.selectedInvition.attachments &&
                  _ctx.state.data.selectedInvition.attachments.length
                )
                ? (_openBlock(), _createBlock("div", _hoisted_56, [
                    _createVNode("div", _hoisted_57, [
                      _createVNode("label", _hoisted_58, _toDisplayString(_ctx.$t('attachments')), 1),
                      (
                      _ctx.state.data.selectedInvition.attachments &&
                      _ctx.state.data.selectedInvition.attachments.length
                    )
                        ? (_openBlock(), _createBlock(_component_ToDoDetailsAttachment, {
                            key: 0,
                            todoAttachments: _ctx.state.data.selectedInvition.attachments
                          }, null, 8, ["todoAttachments"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_59, [
              (
                  _ctx.state.data.selectedInvition.type === 7 ||
                  _ctx.state.data.selectedInvition.type === 5
                )
                ? (_openBlock(), _createBlock("div", _hoisted_60, [
                    _createVNode("a", {
                      href: "javascript:void(0)",
                      class: "btn default-btn",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.join(_ctx.state.data.selectedInvition)))
                    }, _toDisplayString(_ctx.state.data.selectedInvition.isJoinStatus
                      ? _ctx.$t('approving')
                      : _ctx.$t('approve')), 1),
                    _createVNode("a", {
                      href: "javascript:void(0)",
                      class: "btn secondary-btn",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDeclineModal(_ctx.state.data.selectedInvition)))
                    }, _toDisplayString(_ctx.state.data.selectedInvition.isDeclineStatus
                      ? _ctx.$t('declining')
                      : _ctx.$t('decline')), 1)
                  ]))
                : (_ctx.state.data.selectedInvition.type != 4)
                  ? (_openBlock(), _createBlock("div", _hoisted_61, [
                      _createVNode("a", {
                        href: "javascript:void(0)",
                        class: "btn default-btn",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.join(_ctx.state.data.selectedInvition)))
                      }, _toDisplayString(_ctx.state.data.selectedInvition.isJoinStatus
                      ? _ctx.$t('joining')
                      : _ctx.$t('join')), 1),
                      _createVNode("a", {
                        href: "javascript:void(0)",
                        class: "btn secondary-btn",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showDeclineModal(_ctx.state.data.selectedInvition)))
                      }, _toDisplayString(_ctx.state.data.selectedInvition.isDeclineStatus
                      ? _ctx.$t('declining')
                      : _ctx.$t('decline')), 1)
                    ]))
                  : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_62, [
      _createVNode("div", _hoisted_63, [
        _createVNode("div", _hoisted_64, [
          _createVNode("div", _hoisted_65, [
            _createVNode("div", _hoisted_66, [
              _createVNode("h5", _hoisted_67, _toDisplayString(_ctx.$t('invitation_decline')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.hideDeleteInvitation && _ctx.hideDeleteInvitation(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_68
              ])
            ]),
            _createVNode("div", _hoisted_69, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.data.error.errorsList,
                hasError: _ctx.state.data.error.hasError
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_70, _toDisplayString(_ctx.$t('decline_invitation_confirmation')) + ". ", 1),
              (_ctx.state.data.declineShareProject)
                ? (_openBlock(), _createBlock("div", _hoisted_71, [
                    _createVNode("label", _hoisted_72, _toDisplayString(_ctx.$t('reason_to_decline')), 1),
                    _withDirectives(_createVNode("input", {
                      type: "email",
                      class: "form-control",
                      id: "description",
                      "aria-describedby": "emailHelp",
                      placeholder: "Reason for Decline the Invitation",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.data.description = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.state.data.description]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_73, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.decline && _ctx.decline(...args)))
              }, _toDisplayString(_ctx.state.data.selectedInvition.isDeclineStatus ? _ctx.$t('declining') : _ctx.$t('decline')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                "data-dismiss": "modal",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.hideDeleteInvitation && _ctx.hideDeleteInvitation(...args)))
              }, _toDisplayString(_ctx.$t('no')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_UpgradeSubscriptionModal)
  ]))
}